// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:14
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class ReverseGeoResult_abstract extends BaseObject {
  static $t: string = 'SagaBase.ReverseGeoResult';
  $t: string = 'SagaBase.ReverseGeoResult';

  public static GetMembers(): string[] {
    return ['Location', 'ProjCode', 'Culture', 'Addresses', 'KeywordObjects', 'Error', 'Infos'];
  }

  public GetMembers(): string[] {
    return ReverseGeoResult_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Location: any;
  public ProjCode: string = 'EPSG:4326';
  public Culture: string;
  public Addresses: any[];
  public KeywordObjects: any[];
  public Error: string;
  public Infos: string[];

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
